import {
  Button,
  Callout,
  FormGroup,
  InputGroup,
  Overlay2,
} from '@blueprintjs/core';
import React, { useEffect, useState } from 'react';

import * as api from 'api';
import { Role } from '../../constants';

import { useAppDispatch } from 'hooks';
import { useNavigate } from 'react-router-dom';
import { reloadRole } from 'store/general';
import styles from './AuthModal.module.scss';

enum Status {
  initial,
  success,
  failure,
  loading,
}

function getDefaultView(role: Role) {
  switch (role) {
    case Role.grading:
      return '/grading';
    case Role.admin:
      return '/registration';
    default:
      return '/';
  }
}

export default function AuthModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [status, setStatus] = useState<Status>(Status.initial);

  useEffect(() => {
    setStatus(Status.initial);
  }, [open]);

  const onLoginSubmit = async () => {
    try {
      setStatus(Status.loading);

      await api.login({ email, password });

      setStatus(Status.success);
      const role = await dispatch(reloadRole());
      navigate(getDefaultView(role));

      onClose();
    } catch (err) {
      console.error('Failed to log in', err);

      setStatus(Status.failure);
    }
  };

  return (
    <Overlay2 isOpen={open} onClose={onClose}>
      <div className={styles.content}>
        {status === Status.success ? (
          <Callout intent="success" title="Signed in successfully" />
        ) : (
          <>
            {status === Status.failure && (
              <Callout intent="danger" title="Sign in failed">
                Please check email/password and try again.
              </Callout>
            )}
            <div className={styles.form}>
              <FormGroup label="Email" labelFor="email">
                <InputGroup
                  className={styles.input}
                  id="email"
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormGroup>
              <FormGroup label="Password" labelFor="password">
                <InputGroup
                  className={styles.input}
                  id="password"
                  type="password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormGroup>
            </div>

            <div className={styles.footer}>
              <Button
                loading={status === Status.loading}
                intent="danger"
                text={'Cancel'}
                onClick={onClose}
              />
              <Button
                loading={status === Status.loading}
                intent="success"
                text={'Sign in'}
                onClick={onLoginSubmit}
              />
            </div>
          </>
        )}
      </div>
    </Overlay2>
  );
}
